var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.559 1.667c2.258 0 4.083.891 4.108 3.158v12.65a.87.87 0 0 1-.1.408.863.863 0 0 1-.516.417.833.833 0 0 1-.659-.083l-5.4-2.7-5.408 2.7a.885.885 0 0 1-.408.108.847.847 0 0 1-.842-.85V4.825c0-2.267 1.833-3.158 4.083-3.158h5.142zm.567 5.033H6.85a.653.653 0 0 0-.65.658c0 .366.291.659.65.659h6.275c.358 0 .65-.293.65-.659a.653.653 0 0 0-.65-.658z",
    fill: "#4CA1AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.157bc3f90bb014f2a4892c86ca37d541.svg";
export { ForwardRef as ReactComponent };